/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions,
                  jsx-a11y/no-autofocus */

import {forwardRef, useCallback, useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import _ from 'topmeteo/utils/i18n';

import {editLocation} from 'topmeteo/loc/actionCreators';

import EventListener from 'topmeteo/general/components/EventListener';

import LocationManagerDeleteButton from './LocationManagerDeleteButton';
import LocationManagerFavoriteToggle from './LocationManagerFavoriteToggle';

const EditLocationTitle = _('Edit Location');

const LocationManagerItem = props => {
    const {
        className,
        style,
        innerRef,
        handle,
        location,
        editing,
        onSetEditable,
        onEdit,
        ...itemProps
    } = props;
    const inputRef = useRef();
    const textRef = useRef();
    const {name: initialName, isFavourite} = location;
    const [draft, setDraft] = useState(initialName);
    const [width, setWidth] = useState(0);
    const handleDraftChange = event => setDraft(event.target.value);

    const handleKeyPress = useCallback(
        ({key}) => {
            if (!editing) return;

            if (key === 'Enter') {
                onEdit(draft);
                onSetEditable();
            }

            if (key === 'Escape') {
                setDraft(initialName);
                onSetEditable();
            }
        },
        [initialName, editing, draft, onEdit, onSetEditable, setDraft],
    );

    useEffect(() => {
        if (textRef.current) {
            setWidth(textRef.current.offsetWidth);
        }
    }, [editing]);

    return (
        <EventListener target={window} onKeyUp={handleKeyPress}>
            <li className={classNames('location-manager-item', className)} ref={innerRef} style={style} {...itemProps}>
                {handle}
                <LocationManagerFavoriteToggle location={location.id} isFavourite={isFavourite} />
                {editing ? (
                    <input style={{width}} ref={inputRef} onChange={handleDraftChange} value={draft} autoFocus />
                ) : (
                    <span className="name" ref={textRef}>{draft}</span>
                )}
                <strong className="control icon-pencil" title={EditLocationTitle} onClick={onSetEditable} />
                <LocationManagerDeleteButton location={location.id} />
            </li>
        </EventListener>
    );
};

const mapDispatchToProps = (dispatch, {location: {id}}) => ({
    onEdit: name => dispatch(editLocation(id, name)),
});

const ConnectedLocationManagerItem = connect(null, mapDispatchToProps)(LocationManagerItem);

export default forwardRef((props, ref) => <ConnectedLocationManagerItem {...props} innerRef={ref} />);
